import {
  DirectoryContactDto,
  SearchDirectoriesResultWithContacts,
  SearchDirectoryOrganizationsResult,
  SearchDirectoryPractitionersResult,
} from '@domain/types';
import { Http } from '@services/http';

const DIRECTORY_PATH = '/directory';
const DIRECTORIES_PATH = '/directories';

export async function searchPractitioners(searchParams: {
  identityReference: string;
  searchText?: string;
}): Promise<SearchDirectoryPractitionersResult> {
  return await Http.getInstance().get({ path: `${DIRECTORY_PATH}/practitioners`, searchParams });
}

export async function searchOrganizations(searchParams: {
  identityReference: string;
  searchText?: string;
}): Promise<SearchDirectoryOrganizationsResult> {
  return await Http.getInstance().get({ path: `${DIRECTORY_PATH}/organizations`, searchParams });
}

export async function findByEmail(searchParams: {
  identityReference: string;
  email?: string;
  /** Also returns the telecoms the directory knows but can no longer reach, flagged `inactive`. */
  includeInactive?: boolean;
}): Promise<SearchDirectoriesResultWithContacts> {
  return await Http.getInstance().get({ path: `${DIRECTORIES_PATH}`, searchParams });
}

export async function createDirectoryContact(
  docId: string,
  contact: DirectoryContactDto,
): Promise<DirectoryContactDto> {
  return await Http.getInstance().post({
    path: `${DIRECTORY_PATH}/contacts`,
    body: { document_id: docId, contact },
  });
}

export async function updateDirectoryContact(
  docId: string,
  contact: DirectoryContactDto,
): Promise<DirectoryContactDto> {
  return await Http.getInstance().put({
    path: `${DIRECTORY_PATH}/contacts/${contact.id}`,
    body: { document_id: docId, contact },
  });
}

export async function removeDirectoryContact(directoryContactId: number): Promise<void> {
  return await Http.getInstance().destroy({
    path: `${DIRECTORY_PATH}/contacts/${directoryContactId}`,
  });
}
